import { config, network } from 'api';
import errorHandler from 'lib/utils/errorHandler';

const url = `${config.apiBasePath}/wa`;

/**
 * {
 *    pageType: "SHOP_PRODUCTS",
 *    previousPath: "https://[domain]/browse",
 *    pageComponents: [{
 *      id: "string",
 *      type: "FOP_REGULAR",
 *      fields: {},
 *    }],
 *    pageStatistics: [{
 *      fields: {},
 *    }],
 * }
 */
export function reportPageView(pageViewId, pageView, processReturnedData) {
  if (!pageViewId || !pageView) {
    return new Promise().reject();
  }

  return network.put(`${url}/pv`, {
    body: JSON.stringify({
      pageViewId,
      ...pageView,
    }),
  })
    .then(data => {
      if (processReturnedData) {
        processReturnedData(data);
      }
    })
    .catch(errorHandler);
}

/**
 *  {
 *    "type": "EVENT_TYPE", // has to be defined in pageEventTypes.js and in PageEventType enum (BE)
 *    "fields": {},
 *  }
 */
export function reportPageEvents(pageViewId, pageEvents) {
  if (!pageViewId || !pageEvents) {
    return new Promise().reject();
  }
  return network.post(`${url}/pe`, {
    body: JSON.stringify({
      pageViewId,
      pageEvents,
    }),
  })
    .catch(errorHandler);
}

/**
 *  {
 *    "pageComponents": [
 *      {
 *        "fields": {},
 *        "type": "BOP"
 *      }
 *    ]
 *   }
 */
export function reportPageComponents(pageViewId, pageComponents) {
  if (!pageViewId || !pageComponents) {
    return new Promise().reject();
  }
  return network.post(`${url}/pc`, {
    body: JSON.stringify({
      pageViewId,
      ...pageComponents,
    }),
  });
}

export function reportBasketQuantityUpdates(pageViewId, basketQuantityUpdates) {
  if (!pageViewId || !basketQuantityUpdates) {
    return new Promise().reject();
  }
  return network.post(`${url}/bqu`, {
    body: JSON.stringify({
      pageViewId,
      ...basketQuantityUpdates,
    }),
  })
    .catch(errorHandler);
}
